<body>
    <app-header-new></app-header-new>
    <app-all-courses [courseList]="courseList" [isShowAll]="isShowAll"></app-all-courses>
    <app-footer-new></app-footer-new>
</body>